import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioCollectiveDiscountEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioCollectiveDiscountEntity
